import * as TYPES from "./actionTypes"

export const getImageListDropDown = () => ({
  type: TYPES.GET_IMAGE_LIST_DROPDOWN,
})

export const storeImageListDropdown = data => ({
  type: TYPES.STORE_IMAGE_LIST,
  payload: data,
})

export const storeCanvas = data => ({
  type: TYPES.STORE_CANVAS,
  payload: data,
})
